import { render, staticRenderFns } from "./QuotationMain.vue?vue&type=template&id=a4e14650&scoped=true&"
import script from "./QuotationMain.vue?vue&type=script&lang=js&"
export * from "./QuotationMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e14650",
  null
  
)

export default component.exports